import React from 'react';
import {
  Button,
  Modal,
} from '@mairistem/composants';
import { Icon } from '@mairistem/finances-utils';
import NatureJuridiqueCategoriePesPicker from './NatJuridiqueCatPesPicker/NatJuridiqueCatPesPicker';

interface ModalNatJuridiquesCatPesProps {
  categoriePes: string;
  natureJuridiquePes: string;
  onClose: any;
  onCancel: any;
}

const ModalNatJuridiquesCatPes = ({
  categoriePes: categoriesPesProps,
  natureJuridiquePes: natureJuridiquePesProps,
  onClose,
  onCancel,
}: ModalNatJuridiquesCatPesProps) => {
  const [categoriePes, setCategoriePes] = React.useState<string>(categoriesPesProps);
  const [natureJuridiquePes, setNatureJuridiquePes] = React.useState<string>(natureJuridiquePesProps);
  const [loading, setLoading] = React.useState<boolean>(false);

  const handleClose = async () => {
    setLoading(true);

    if (onClose) {
      await onClose({
        categoriePes,
        natureJuridiquePes,
      });
    }

    setLoading(false);
  };

  const handleCancel = () => {
    setCategoriePes('');
    setNatureJuridiquePes('');

    if (onCancel) {
      onCancel();
    }
  };

  const handleUpdate = (cat: string, nat: string) => {
    setCategoriePes(cat);
    setNatureJuridiquePes(nat);
  };

  return (
    <Modal
      open
      size="fullscreen"
      closeOnDimmerClick
      closeIcon
      onClose={handleCancel}
    >
      <Modal.Header>Nature Juridique et Catégorie PES</Modal.Header>
      <Modal.Content>
        <NatureJuridiqueCategoriePesPicker
          onClick={handleUpdate}
          onDoubleClick={handleClose}
          natureJuridiquePes={natureJuridiquePes}
          categoriePes={categoriePes}
        />
      </Modal.Content>
      <Modal.Actions>
        <Button
          onClick={handleCancel}
          size="tiny"
          basic
          disabled={loading}
        >
          <Icon name="cancel" />
          Annuler
        </Button>
        <Button
          color="green"
          onClick={handleClose}
          disabled={loading}
        >
          <Icon name="checkmark" />
          Valider
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default ModalNatJuridiquesCatPes;
